// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import { useDialogContext } from '@ariakit/react'
import React from 'react'

import { NextLink } from '../../../../app/_components/navigation/NextLink'
import { trackEvent } from '../../../../lib/analytics'
import { useProductHrefWithQuery } from '../../../../lib/routing'

import * as Styles from './styles'

type ColorGalleryTileProps = {
  colorDisplayValue: string
  colorKey: string
  productGroupHandle: string
  imageUrl: string
}

// Extracted to prevent nesting hooks
const ColorGalleryTile = ({
  colorDisplayValue,
  colorKey,
  productGroupHandle,
  imageUrl,
}: ColorGalleryTileProps) => {
  const productUrl = useProductHrefWithQuery({
    color: colorKey,
    handle: productGroupHandle,
  })
  const dialogContext = useDialogContext()

  return (
    <NextLink
      href={productUrl}
      {...trackEvent({
        action: 'click color tile',
        category: 'product details',
        value: `${colorKey}`,
      })}
      onClick={() => dialogContext?.hide()}
    >
      <Styles.Tile
        src={imageUrl}
        alt={`${colorDisplayValue} image`}
        loading='lazy'
        widths={{
          unit: 'px',
          sm: 150,
          md: 150,
        }}
        aspectRatios={{
          sm: 1,
          md: 1,
        }}
      />
      <Styles.TileName>{colorDisplayValue}</Styles.TileName>
    </NextLink>
  )
}

export default ColorGalleryTile
